export const EnvironmentDefault: Map<string, string> = new Map([
    ["bleu", "Bleu"],
    ["delos", "Delos"],
    ["prod", "PROD"]
]);

export const RingDefault: Map<string, string> = new Map([
    ["bleu", "All"],
    ["delos", "All"],
    ["all", "All"]
]);

export const getDefaultValueScopeType = (scopeType: string, cloudServiceEnvironment: string, valueMap?: Map<string, string> | string): string | undefined => {
    if (typeof valueMap === "string") {
        return valueMap;
    }

    if (valueMap) {
        const env = cloudServiceEnvironment.toLowerCase();
        switch (scopeType.toLowerCase()) {
            case "environment": {
                return valueMap.get(env) || valueMap.get("prod") || undefined;
            }
            case "ring":
                return valueMap.get(env) || valueMap.get("all") || undefined;
            default:
                return undefined;
        }
    }
};
